import { CircularProgress } from "@material-ui/core";
import React from "react";
import styled from "styled-components";

import { getStaticUrl } from "js/config";
import { themeColors } from "js/react/sharedStyles";

const LoadingBotContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    gap: 30px;
`;

const LoadingText = styled.div`
    font-family: "Source Sans Pro";
    color: ${themeColors.darkestGray};
    font-size: 24px;
    font-weight: 600;
    line-height: 24px;
`;

const LoadingSubtext = styled.div`
    color: ${themeColors.darkGray};
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
`;

export function LoadingState({
    title,
    subtitle,
}: {
    title: string;
    subtitle: string;
}) {
    return (
        <LoadingBotContainer>
            <img src={getStaticUrl("/images/bai-bot/bai-bot-loop.gif")} width={150} height={150} style={{ marginBottom: 0 }} />
            <LoadingText>{title}</LoadingText>
            <LoadingSubtext>{subtitle}</LoadingSubtext>
            <CircularProgress size={45} thickness={5} style={{ color: themeColors.ui_blue, marginTop: 30 }} />
        </LoadingBotContainer>
    );
}
